export const EmailInput = ({ label, dispatch, name, value, placeholder = null }) => {
    return(
        <label className="emailInput">
            <span>{label}</span>
            <input placeholder={ placeholder ? placeholder : null } type="email" onChange={(e) => { e.preventDefault(); dispatch({ type: "change", name, value: e.target.value })}} value={value} name={name}/>
        </label>
    )
}